<template>
  <div class="p_demand_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>雇员</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/signupList' }">流程管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: dtlPath }">{{pageTitle}}</el-breadcrumb-item>
                <el-breadcrumb-item>个人详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="r_dtl_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="简历信息" name="简历信息"></el-tab-pane>
          <el-tab-pane label="在职信息" name="在职信息" v-if="strWorkState=='在职'"></el-tab-pane>
          <el-tab-pane label="签约信息" name="签约信息" v-if="strWorkState=='在职'"></el-tab-pane>
          <el-tab-pane label="跟进记录" name="跟进记录"></el-tab-pane>
          <el-tab-pane label="流程记录" name="流程记录"></el-tab-pane>
        </el-tabs>
      <div class="f_list_box" v-if="activeName == '简历信息'" v-loading="formLoading">
        <EditResumeInfo></EditResumeInfo>
      </div>
      <div class="f_list_box" v-if="activeName == '在职信息'">
        <JobInfo></JobInfo>
      </div>
      <div class="f_list_box" v-if="activeName == '跟进记录'">
        <el-table v-loading="followLoading" :data="followData" style="width:100%">
          <el-table-column align="center" label="序号">
            <template slot-scope="{$index}">
                <span>{{(Number(followQuery.currpage) - 1) * Number(followQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="未约面原因">
            <template slot-scope="{row}">
                <span>{{row.StrReason}}</span>
              </template>
          </el-table-column> -->
          <el-table-column align="center" label="跟进内容">
            <template slot-scope="{row}">
                <span>{{row.StrRemark}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="发言人">
            <template slot-scope="{row}">
                <span>{{row.userName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="时间" min-width="100px">
            <template slot-scope="{row}">
                <span>{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="followQuery.currpage"
                :page-size="followQuery.perpage"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 50, 100]"
                layout="total,sizes,prev,pager,next,jumper"
                :total="totalFollow"
            ></el-pagination>
        </div>
      </div>
      <div v-if="activeName == '签约信息'">
        <div style="margin-bottom: 10px;">
          <el-button type="primary" size="small" @click="signing()">&nbsp;登记线下签约信息</el-button>
        </div>
        <el-table v-loading="loading" :data="signingTable" style="width:100%">
          <el-table-column align="center" label="签约时间" fit>
            <template slot-scope="{row}">
                <span>{{row.SignatureTime ? row.SignatureTime.split('T')[0] : ''}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="ContractSubject" align="center" label="签约主体" fit :show-overflow-tooltip="true">
          </el-table-column>
          <!-- <el-table-column prop="TempName" align="center" label="签约模板" fit >
          </el-table-column> -->
          <el-table-column prop="TempType" align="center" label="模板类型" fit>
          </el-table-column>
          <el-table-column align="center" label="合同起始时间" fit>
            <template slot-scope="{row}">
                <span>{{row.ContractStartTime ? row.ContractStartTime.split('T')[0] : ''}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="合同到期时间" fit>
            <template slot-scope="{row}">
                <span>{{row.ContractEndTime ? row.ContractEndTime.split('T')[0] : ''}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="附件" fit>
            <template slot-scope="{row}">
                <span class="blueName cp" v-if="row.AttachUrl" @click="down(row.AttachUrl)">下载</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange3" :current-page.sync="signingQuery.pageNum" :page-size="signingQuery.pageSize" @size-change="handleSizeChange3" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager,next,jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
      <div class="f_list_box" v-if="activeName == '流程记录'">
        <el-table v-loading="serviceLoading" :data="serviceData" style="width:100%">
          <el-table-column align="center" label="序号">
            <template slot-scope="{$index}">
                <span>{{(Number(serviceQuery.currpage) - 1) * Number(serviceQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrprojectName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="岗位名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.JobCategory}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="流程名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrState}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="流程时间" min-width="130px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span v-if="row.StrState == '已报名'">{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
              <span v-if="row.StrState == '约面'">{{isNull(row.Dtviewtime)?'':row.Dtviewtime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '入职'">{{isNull(row.DtInducttime)?'':row.DtInducttime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '离职'">{{isNull(row.Dtquittime)?'':row.Dtquittime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '通过'">{{isNull(row.Dtreachtime)?row.Dtadopttime:row.Dtreachtime}}</span>
              <span v-if="row.StrState == '到面'">{{isNull(row.Dtfacetime)?'':row.Dtfacetime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '未入职'">{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" min-width="140px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.Username}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="操作时间" min-width="130px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程备注" min-width="140px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrRemark}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange2"
                :current-page.sync="serviceQuery.currpage"
                :page-size="serviceQuery.perpage"
                @size-change="handleSizeChange2"
                :page-sizes="[10, 20, 50, 100]"
                layout="total,sizes,prev,pager,next,jumper"
                :total="totalService"
            ></el-pagination>
        </div>
      </div>
      </div>
    </div>

    <div class="offlineSigning">
      <el-dialog title="线下签约登记" :visible.sync="showOfflineSigning" width="800px">
        <el-form :model="offRegForm" :rules="offRegRules" ref="offRegForm" :inline="true" label-width="125px">
          <el-form-item label="身份证姓名" prop="Name">
            <el-input v-model="offRegForm.Name" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="StrIdCard">
            <el-input v-model="offRegForm.StrIdCard" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="StrObjName">
              <el-select v-model="offRegForm.StrObjName" placeholder="" clearable filterable style="width:200px">
                <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="员工签约主体" prop="ContractSubject">
            <el-select v-model="offRegForm.ContractSubject" placeholder="" clearable filterable style="width:200px">
              <el-option v-for="(item,index) in legList" :key="index" :value="item.enterpriseName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约类型" prop="TempType">
            <el-select v-model="offRegForm.TempType" placeholder="" clearable filterable style="width:200px">
              <el-option value="用工协议"></el-option>
              <el-option value="证明文件"></el-option>
              <el-option value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职日期" prop="dtEntryBDate">
            <el-date-picker type="date" placeholder="" v-model="offRegForm.dtEntryBDate" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同签约时间" prop="SignatureTime">
            <el-date-picker type="date" placeholder="" v-model="offRegForm.SignatureTime" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同起始时间" prop="ContractStartTime">
            <el-date-picker type="date" placeholder="" v-model="offRegForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同结束时间" prop="ContractEndTime">
            <el-date-picker type="date" placeholder="" v-model="offRegForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px"></el-date-picker>
          </el-form-item>
          <el-form-item label="附件">
            <div class="upload_box">
              <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                <el-button size="small" type="success">上传附件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showOfflineSigning = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmOfflineSigning">确定</el-button>
        </span>
      </el-dialog>
      </div>
  </div>
</template>

<script>
import xz from "./../../common";
import EditResumeInfo from "./components/editResumeInfo.vue";
import JobInfo from "./components/inJobInfo.vue";
export default {
   components: {
    EditResumeInfo,
    JobInfo
  },
  name: "dtlResource",
  data() {
    return {
      // 简历来源
      originList:[],
        isDetail: true,
        pageTitle:'',
        activeName:'简历信息',
        // 跟进记录
        followLoading: false,
        followData: [],
        // 流程记录
        serviceLoading: false,
        formLoading: false,
        serviceData: [],
        // 部门参数
      departQuery:{
        strorgancode:'',
        roletype:''
      },
      departMemberQuery: {
          keyword: '',
          strWorkState: '在职',
          currpage: 1,
          perpage: 100000
      },
      // 跟进记录
      followQuery:{
        resumeId:'', //简历id
        currpage: 1,
        perpage: 10
      },
      totalFollow: 0,
      // 流程记录
      serviceQuery:{
        resumeId:'', //简历id
        roletype:localStorage.loginRoletype,
        currpage: 1,
        perpage: 10
      },
      totalService: 0,
      enterTagQuery:{
        resumeIds: '', // 简历id (多条用,连接)
        labelIds: '' // 标签id (多条用,连接)
      },
      addlabelVisible: false,
      roleType: '',
      dtlPath:'',
      collapseShow:true,
      // 编辑按钮文字
      editTxt:'编辑',
      // 在离职状态
      strWorkState:'',
      signingQuery:{
        pageNum:1,
        pageSize:10,
        PhoneNum:''
      },
      signingTable:[],
      showOfflineSigning:false,//线下登记弹窗
      offRegForm: { //线下签约登记表单
          Id: '',
          Name:'',
          PhoneNum:'',
          StrObjName: '', //项目名称
          StrIdCard: '', //身份证
          TempType:'',//签约类型
          StrObjName:'',//项目名称
          ContractSubject: '', //员工签约主体
          SignatureTime: '', //合同签约时间
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          dtEntryBDate:'',//入职日期
          AttachUrl: '', //合同附件
        },
        offRegRules: {
          Name: {
            required: true,
            message: '请输入姓名',
            trigger: 'change'
          },
          StrIdCard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'change'
          },
          StrObjName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          dtEntryBDate: {
            required: true,
            message: '请选择入职日期',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          TempType: {
            required: true,
            message: '请选择员工签约类型',
            trigger: 'change'
          },
          SignatureTime: {
            required: true,
            message: '请选择合同签约时间',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
        },
        legList: [], //主体列表
        fileList:[],
        headPath:this.$store.state.EMP.docPath,
        proList: [], //项目列表
    }
  },
  created() {
    this.followQuery.resumeId = this.$route.query.id
    this.serviceQuery.resumeId = this.$route.query.id
    this.pageTitle = this.$route.query.pageTitle
    this.offRegForm.DtEntryBdate = this.$route.query.dtEntryBDate
    if(this.pageTitle == '个人资源'){
      this.dtlPath = '/personalResources?active='+this.pageTitle
    }
    if(this.pageTitle == '公海资源'){
      this.dtlPath = '/publicResources?active='+this.pageTitle
    }
    if(this.pageTitle == '报名'||this.pageTitle == '已约面'||this.pageTitle == '到面'||this.pageTitle == '通过'||this.pageTitle == '在职'||this.pageTitle == '异常'||this.pageTitle == '离职'){
      this.dtlPath = '/signupList?active='+this.pageTitle
    }
    this.getResumeDtl(this.$route.query.id)
    this.departQuery.roletype = localStorage.loginRoletype
    this.roleType = localStorage.loginRoletype
    this.getLegalSubjectList()
    this.getSearchJobProList()
  },
  methods: {
    toggleHandle(){
      this.collapseShow = !this.collapseShow
    },
    // 获取简历详情
    getResumeDtl(id){
        xz.getResumeDetail({ResumeId: id}).then(res => {
            // console.log('getResumeDtl', res)
            if (res.status == 'ok') {
                this.signingQuery.PhoneNum = res.msg.StrMobile;
                this.offRegForm.PhoneNum = res.msg.StrMobile;
                this.offRegForm.Name = res.msgonwork[0].StrEmpName;
                this.offRegForm.StrIdCard = res.msgonwork[0].StrIdCard;
                let resMsg = res.msgonwork
                if(!this.isNull(resMsg)){
                  this.strWorkState = '在职'
                }
                // this.strWorkState = resMsg.StrWorkState
                // console.log('getResumeDtl', resMsg)
            }
        });
    },
    // 返回
    backHandle(){
      this.$router.back()
      // this.$router.go(-1) // 后退+刷新
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      if(tab.name == '跟进记录'){
        this.getFollowList()
      }else if(tab.name == '流程记录'){
        this.getServiceList()
      }else if(tab.name == '签约信息'){
        this.getSigningInfo()
      }
    },
    //分页
    handleCurrentChange(val){
        this.followQuery.currpage = Number(val)
        this.getFollowList()
    },
    handleSizeChange(val) {
        this.followQuery.currpage = 1
        this.followQuery.perpage = Number(val)
      this.getFollowList()
    },
    handleCurrentChange2(val){
        this.serviceQuery.currpage = Number(val)
        this.getServiceList()
    },
    handleSizeChange2(val) {
        this.serviceQuery.currpage = 1
        this.serviceQuery.perpage = Number(val)
      this.getServiceList()
    },
    //获取跟进记录
    getFollowList() {
      this.followLoading = true
      xz.getresumePsnfowrecords(this.followQuery).then(res => {
        // console.log('followQuery', res)
        if (res.status == 'ok') {
          this.followData = res.msg
          this.totalFollow = res.totalcount
        } else {
          this.followData = []
          this.totalFollow = 0
        }
        this.followLoading = false
      })
    },
    //获取流程记录
    getServiceList() {
      this.serviceLoading = true
      xz.getresumePsnstatusrecords(this.serviceQuery).then(res => {
        // console.log('serviceQuery', res)
        if (res.status == 'ok') {
          this.serviceData = res.msg
          this.totalService = res.totalcount
        } else {
          this.serviceData = []
          this.totalService = 0
        }
        this.serviceLoading = false
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    },
    //获取签约信息
    getSigningInfo() {
      this.loading = true;
      this.totalcount = 0;
      xz.getContractListByPhone(this.signingQuery, this.roleType).then(res => {
        if (res.status == 'ok') {
          this.signingTable = res.data.ContractList1;
          this.totalcount = res.data.totalcount;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error('获取签约信息出错');
          this.signingTable = [];
          this.totalcount = 0;
        }
      })
    },
    //分页
    handleCurrentChange3(val){
        this.signingQuery.pageNum = Number(val)
        this.getSigningInfo()
    },
    handleSizeChange3(val) {
      this.signingQuery.pageNum = 1
      this.signingQuery.pageSize = Number(val)
      this.getFollowList()
    },
    //登记线下信息
    signing(){
      this.showOfflineSigning = true;
    },
    //取签约主体列表
    getLegalSubjectList() {
        xz.getLegalSubjectList('', this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data
          } else {
            this.$message.error('获取签约主体列表出错');
          }
        })
      },
    //上传附件
    success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.offRegForm.AttachUrl = res
          } else {
            this.offRegForm.AttachUrl = ''
          }
        });
      },
      handleRemove(file) {
        this.offRegForm.AttachUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
    confirmOfflineSigning() {
      this.$refs["offRegForm"].validate((valid) => {
        if (valid) {
          xz.addOfflineSigning(this.offRegForm, this.roleType).then(res => {
            if (res.status == 'ok') {
              this.$message.success('线下签约登记成功！');
              this.getSigningInfo();
            } else {
              this.$message.error('系统出错！')
            }
            this.showOfflineSigning = false;
          })
        }
      })
    },
    down(url) {
      let d = url.replace("\"", "").replace("\"", "");
      var path = this.headPath + d;
      const aTag = document.createElement('a')
      aTag.href = path
      aTag.click();
    },
    // 获取项目列表
    getSearchJobProList() {
        let proNameQuery = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(proNameQuery).then((res) => {
          if (res.status == "ok") {
            this.proList = res.msg;
          } else {
            this.proList = [];
          }
        });
      },
  }
}
</script>
<style>
.dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 0;
}
.dia_label_box .el-checkbox.is-bordered.is-checked,
.dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #19BD92;
}
.dia_label_box{
  max-height: 400px;
  overflow-y: auto;
}
.r_more_box .dia_label_box .dia_groupname{
  font-weight: normal;
}
.dia_label_box .dia_groupname{
  font-size: 14px;
  line-height: 25px;
  color:#333;
  font-weight: bold;
  margin-top: 5px;
  /* border-bottom: 1px solid #ddd; */
}
.dia_label_box .el-checkbox{
  border: 1px solid #ddd;
  padding: 2px 3px;
  border-radius: 3px;
  height: auto;
  margin: 5px 20px 0 0;
}
.p_resource_module .r_dropDownScreen .el-checkbox__label,
.dia_label_box .el-checkbox__label{
  padding-left: 3px;
}
.f_form_titles{
  display: flex;
  align-items: center;
}
.d_info_txt{
  width: 210px;
  font-size: 14px;
  color: #000;
  padding-left: 15px;
  box-sizing: border-box;
}
.r_width01 .el-form-item__label{
  width: 145px!important;
}
.re_dtl_form02.re_dtl_form .el-form-item{
  margin-bottom: 8px;
}
.re_dtl_form01.re_dtl_form .el-form-item{
  margin-bottom: 17px;
}
.r_dtl_box .el-input.is-disabled .el-input__inner,
.r_dtl_box .el-textarea.is-disabled .el-textarea__inner{
  color: #000;
}
.r_dtl_box{
    background-color: #fff;
    padding: 10px;
}
.re_dtl_form .el-input,
.re_dtl_form .el-date-editor.el-input{
    width: 210px;
}
.r_dtl_box .all_width,.r_dtl_box .all_width1{
  width: 100%;
}
.r_dtl_box .all_width .el-form-item__content{
  width: calc(100% - 125px);
  /* min-width: 830px; */
}
.r_dtl_box .all_width1 .el-form-item__content{
  width: calc(100% - 125px);
}
.re_dtl_form{
    margin-top: 10px;
}
.res_dialog .el-dialog__body{
    padding: 5px 20px 10px 20px;
}
.r_dtl_box .el-form--inline .el-form-item{
  margin-right: 0;
}
.e_txt_box{
  font-size: 14px;
  color:#409eff;
  text-align: right;
}
.re_dtl_form .r_line_box .el-input{
  width: 98px;
}
</style>
<style scoped>
.r_line_box{
  display: flex;
  align-items: center;
}
.r_line_txt{
  width: 4px;
  height: 1px;
  background-color: #DCDFE6;
  margin: 0 5px;
}
.f_form_btn{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color:#333;
  border-bottom: 1px solid #ddd;
}
.labGroup {
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.f_list_box{
    background-color: #fff;
    /* padding: 10px 20px; */
}
.f_form_title{
    font-size: 14px;
    color:#333;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}
.p_demand_box{
    padding: 10px 20px;
    background-color: #fff;
}
</style>